import { configure as configureWidget } from "instantsearch.js/es/widgets";

export const ttecSolutionsConfigure = configureWidget({
  hitsPerPage: 40,
  distinct: true,
  facetingAfterDistinct: true,
});
